import { useStoreon } from 'storeon/react';
import { State } from 'store/types';
import { LANDINGS_STORE_NAME } from 'modules/landings-info';
import { SERVICE_CATEGORIES_STORE_NAME } from 'modules/service-categories';
import { OtherData } from 'common/components/other-section/other-section-types';
import {
  getServiceCategoryData,
  getLandingOtherData,
} from 'common/components/other-section/other-section-utils';

/**
 * Возвращает данные для блока "Другие услуги"
 * @param {string} name - Имя лендинга
 */
export const useOtherDataSelector = (name: string): OtherData[] => {
  const {
    landings: { landingsList },
    serviceCategories: { serviceCategoriesList },
  } = useStoreon<State>(LANDINGS_STORE_NAME, SERVICE_CATEGORIES_STORE_NAME);
  const landing = landingsList?.find(({ landingName }) => landingName === name);
  if (!landing) {
    return [];
  }

  const { otherSection, serviceCategories } = landing;
  const serviceOtherData = getServiceCategoryData(serviceCategories, serviceCategoriesList);
  const landingOtherData = getLandingOtherData(otherSection, landingsList);

  return [...serviceOtherData, ...landingOtherData.slice(0, 3)];
};
